import 'material-design-icons-iconfont/dist/material-design-icons.css' // Ensure you are using css-loader
import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)

const vuetify = new Vuetify({
  icons: {
    iconfont: 'md',
  },
  theme: {
    themes: {
      light: {
        black: '#272727',
        black2: '#161616',
        lightgray: '#E4E3E1',
        darkgray: '#878a8c',
        gainsboro: '#d3d3d3',
        AliceBlue: '#F0F8FF',
        aqua: '#28A0A3',
        green: '#1BB493',
        darkblue: '#021330',
        lightblue: '#053DA2',
        purple: '#995d81',
      },
    },
  },
  breakpoint: {
    thresholds: {
      lg: 1360,
    },
    scrollbarWidth: 10,
  },
})

export default vuetify
